import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

const selectSelf = (state: RootState) => state.common;

export const selectSettings = createSelector(selectSelf, (common) => common.settings);

export const selectResources = createSelector(selectSelf, (common) => common.resources);

export const selectAppUi = createSelector(selectSelf, (common) => common.appUi);

export const selectFeatureFlags = createSelector(selectSelf, (common) => common.featureFlags);
